import { Typography } from '@cp/ds/src/components/typography';
import React from 'react';
import { H1RenderConfig } from '../../hooks/useH1';
import { H1Props, ItemProps } from './model';

const defaultRenderers: {
  [Type in H1RenderConfig[number]['type']]: (
    config: { type: Type } & H1RenderConfig[number],
    index: number,
    props?: ItemProps[Type],
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ) => React.ReactElement<{ key: string } & any, any> | null;
} = {
  common: ({ content }, index, props) => (
    <React.Fragment key={`${content}-${index}`} {...props}>
      {content}
    </React.Fragment>
  ),
  bold: ({ content }, index, props) => (
    <Typography component="span" key={`${content}-${index}`} variant="h6" {...props}>
      {content}
    </Typography>
  ),
  br: (_, index, props) => <br key={`br-${index}`} {...props} />,
};

export const H1: React.FC<H1Props> = ({ config, rootProps, itemProps }) => {
  return (
    <Typography component="h1" variant="h6" {...rootProps}>
      {config?.map((itemConfig, index) =>
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        defaultRenderers[itemConfig.type](itemConfig as never, index, itemProps?.[itemConfig.type]),
      )}
    </Typography>
  );
};
